export const TWO_DECIMALS = 2;
export const REQUIRED_FIELD_STAR = '*';
export const FIVE_SECONDS = 5;
export const ONE_AND_A_HALF_SECONDS = 1500;
export const FIVE_MINUTES = 5 * 60 * 1000;
export const ONE_SECOND_IN_MS = 1000;
export const EIGHTHEEN = '18';
export const SINGLE_SPACE = ' ';
export const PLUS = '+';
export const SLASH = '/';
export const MINUS = '-';
export const DOT = '.';
export const QUESTION_MARK = '?';
export const TWO_DECIMALS_ZERO = '0.00';

export const DH = 'DH';
export const P = 'P';
export const EW = 'EW';

export const MAX_SNACKBARS = 3;

export const N_A = 'N/A';

export const INVALID_ID = -1;
